export default "__VITE_ASSET__CftmtP0j__"